module.exports = __webpack_public_path__ + "media/images/emblems/Blumenstein-coat_of_arms-f608504ef6f85a6dda4ebd806dfb35ee.svg";